import { useEffect } from "react";
import "./SortingCard.scss";

const SortingCard = ({ sort_by_options, setSortValue, sortValue, onClose }) => {
  useEffect(() => {
    if (sort_by_options?.default) {
      setSortValue(sortValue || sort_by_options.default);
    }
  }, [sort_by_options]);

  const handleOptionChange = (e) => {
    setSortValue(e.target.value);
    onClose?.();
  };

  return (
    <div className="store-sorting-card">
      <div className="store-sort-header">Sort by</div>
      <div className="store-sort-content">
        <ul>
          {sort_by_options?.option_labels?.map((item) => (
            <li key={item.value}>
              <input
                type="radio"
                id={item.value}
                name="sortOption"
                value={item.value}
                checked={sortValue === item.value}
                onChange={handleOptionChange}
              />
              <label htmlFor={item.value}>{item.label}</label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SortingCard;
